const fallbackMode = 'PROD'; // Default mode if the appsettings file read fails

let settings = {};
settings.serverTechSettings = {};
settings.clientSettings = window.clientSettings || {};
if (!window.clientSettings) {
  console.error('The clientSettings.js file is not available. Initializing empty values.');
}

try {
  settings.serverTechSettings = await fetchServerTechSettings(); // Await the fetch to ensure server settings are received before proceeding
} catch (e) {
  console.error('Failed to fetch server tech settings: ', e);
}

settings.mode = settings.serverTechSettings.mode ? settings.serverTechSettings.mode.toUpperCase() : fallbackMode;
settings.urls = settings.clientSettings.linkSettings ? settings.clientSettings.linkSettings[settings.mode] : [];
settings.niaUrl = settings.clientSettings.linkSettings.niaLoginUrl ? settings.clientSettings.linkSettings.niaLoginUrl[settings.mode] : "";
document.title = (["DEV1-RC", "DEV2", "TEST"].includes(settings.mode) ? settings.mode + ' ' : "") + 'Portál katastru a zeměměřictví | ČÚZK';

async function fetchServerTechSettings() {
  try {
    const response = await fetch("/info");
    if (!response.ok) {
      throw new Error(
        "Network response was not ok; Fetching server tech settings."
      );
    }
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new TypeError("Response is not JSON");
    }
    return await response.json();
  }
  catch (error) {
    console.error("Fetch error, failed to fetch server tech settings:", error);
    console.error("Switching to fallback mode:", fallbackMode);
    return { mode: fallbackMode };
  }
}

// Fetches the authenticated-only environment fields (version, dbEnv, wsEnv,
// wsNessEnv, env) from /info/tech and merges them into settings.serverTechSettings.
// Call this only from the protected entrypoint — anonymous callers will get a
// redirect/401 and the footer will fall through to the '---' placeholders.
async function loadTechSettings() {
  try {
    const response = await fetch("/info/tech");
    if (!response.ok) {
      throw new Error("Network response was not ok; Fetching /info/tech.");
    }
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new TypeError("Response is not JSON");
    }
    const tech = await response.json();
    Object.assign(settings.serverTechSettings, tech);
  } catch (error) {
    console.error("Fetch error, failed to fetch /info/tech:", error);
  }
}

console.log('Exported settings:', settings);
export { settings, loadTechSettings };